import { hasCapability, type User } from "../base";

export const phoneProvider = {
  access: (user: User) => hasCapability(user, "phoneProvider.access"),
  phones: {
    list: (user: User) => hasCapability(user, "phoneProvider.phones.list"),
  },
};
